import { apiV3Client } from './BaseRepository';

export function disconnectATS(VaultName) {
  return apiV3Client.delete(`oauth/vault?vaultName=${VaultName}`);
}
